import { useState } from "react";
import { Check } from "lucide-react";
import { Btn } from "../../components/ui/Btn";
import { FieldLabel, Modal, inputStyle } from "../../components/ui/Modal";

/** Add or edit a section's title and description. */
export function SectionModal({ initial, isNew, onSave, onClose }: {
  initial: { title: string; description: string }; isNew: boolean; onSave: (v: { title: string; description: string }) => void; onClose: () => void;
}) {
  const [title, setTitle] = useState(initial.title);
  const [description, setDescription] = useState(initial.description);
  const valid = title.trim().length > 0;

  return (
    <Modal title={isNew ? "Add Section" : "Edit Section"} onClose={onClose} width={440}
      footer={<>
        <Btn variant="ghost" size="md" onClick={onClose}>Cancel</Btn>
        <Btn variant="primary" size="md" disabled={!valid} onClick={() => valid && onSave({ title: title.trim(), description: description.trim() })}><Check size={13} /> Save Section</Btn>
      </>}>
      <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
        <div>
          <FieldLabel required>Section title</FieldLabel>
          <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="e.g. Identity Verification" style={inputStyle} autoFocus />
        </div>
        <div>
          <FieldLabel hint="Optional — shown to users below the section title">Section description</FieldLabel>
          <textarea value={description} onChange={(e) => setDescription(e.target.value)} rows={3} style={{ ...inputStyle, resize: "vertical", lineHeight: 1.5 }} />
        </div>
      </div>
    </Modal>
  );
}
